export const getFormattedNumber = (n = 0, decimals = 0, unit = '', forceSign = false): string => {	if (typeof n !== 'number') {
		console.log(n, 'is not a valid number');
		return n;
	}	const s = n.toFixed(decimals);
	const [integerPart, decimalPart] = s.split('.');
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	const finalUnit = unit ? '\u00a0' + unit : '';
	const sign = (forceSign && n >= 0) ? '+' : '';

	return `${sign}${formattedInteger}${decimalPart !== undefined ? '.' + decimalPart : ''}${finalUnit}`;
};

export const getFormattedPercent = (n = 0, decimals = 1, forceSign = false): string => {
	return getFormattedNumber(n, decimals, '%', forceSign);
};

export const getFormattedMultiplier = (n = 0, decimals = 1): string => {
	return getFormattedNumber(n, decimals, 'x');
};
